import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import 'tails-ui/dist/index.css';
import DataTable from 'react-data-table-component';

let userRole;
const inpersonateFlag = localStorage.getItem("inpersonate");
class DocumentListView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        userRole = localStorage.getItem("userRole");
    }
    render() {
        function createMarkup(documentname) {
            return { __html: documentname };
        }

        const columns = [
            {
                name: 'Upload Date',
                selector: 'upload_on',

            },
            {
                name: 'Version',
                selector: 'version',

            },
            {
                name: 'Document Name',
                selector: 'document_name',
                cell: row => <div dangerouslySetInnerHTML={createMarkup(row.document_name)} />

            },
            {
                name: 'File',
                selector: 'document_link',
                cell: row => <div className="link-wrap">
                    {/* <a href="" download={row.document_link} data-attr={row.document_link}> Download</a> */}
                    <a href="" data-filename={row.document_name} data-attr={row.document_link} onClick={this.props.handledocumentDownload}> Download</a>
                </div>

            },
            {
                name: 'Action',
                selector: 'ID',
                cell: row => <div className="action-button-wrap">
                    <span className={row.doc_status == 'active' ? "active-doc" : ''} id={row.ID} data-status={row.doc_status} onClick={this.props.handleactiveDocument}>ACTIVE</span>
                    <span className={row.doc_status == 'deactivate' ? "deactive-doc" : ''} id={row.ID} data-status={row.doc_status} onClick={this.props.handleactiveDocument}>DEACTIVE</span>
                    <span className="delete-doc" id={row.ID} onClick={this.props.handledeleteDocument}>Delete</span>
                </div>,
            }
        ];

        const partnerColumn = [
            {
                name: 'Upload Date',
                selector: 'upload_on',
                sortable: true,

            },
            {
                name: 'Version',
                selector: 'version',

            },
            {
                name: 'Document Name',
                selector: 'document_name',
                sortable: true,
                cell: row => <div dangerouslySetInnerHTML={createMarkup(row.document_name)} />

            },
            {
                name: 'File',
                selector: 'document_link',
                cell: row => <div className="link-wrap">
                    {/* <a href="" download={row.document_link} data-attr={row.document_link}> Download</a> */}
                    <a href="" data-filename={row.document_name} data-attr={row.document_link} onClick={this.props.handledocumentDownload}> Download</a>
                </div>

            },
        ]

        return (
            <div>
                <div className="w-full mb-3 mx-auto flex flex-wrap items-center mt-0 p-6 domain-list-table report-datatable">
                    {'1' === userRole && 'false' === inpersonateFlag ? <DataTable
                        columns={columns}
                        data={this.props.userData}
                        progressPending={this.props.userLoading}
                        pagination={true}
                        paginationTotalRows={this.props.userRows}
                        paginationServer={true}
                        paginationPerPage={20}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onChangePage={this.props.handlePageChange}
                    /> : <div className="partner-datatable"><DataTable
                        columns={partnerColumn}
                        data={this.props.userData}
                        progressPending={this.props.userLoading}
                        pagination={true}
                        paginationTotalRows={this.props.userRows}
                        paginationServer={true}
                        paginationPerPage={20}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onChangePage={this.props.handlePageChange}
                    /> </div>}

                </div>
            </div>
        );
    }

}

export default DocumentListView
